<template>
  <el-form-item :label="item.label" :prop="`${tableName}.${groupName}.${item.key}`">
    <tw-select v-if="item.inputType === 'select'" v-model="model" :options="item.options" clearable />
    <tw-input-format-number v-else-if="item.inputType === 'number'" v-model="model" />
    <el-date-picker v-else-if="item.inputType === 'date'" v-model="model" type="date" placeholder="Select date" />
    <el-input v-else v-model="model" show-word-limit :maxlength="getMaxLength"/>
  </el-form-item>
</template>

<script>
import { getMaxLength } from '@/utils/searchUtil.js';

export default ({
  name: 'TwProcessGroupListEditSimple',
  props: {
    item: Object,
    tableName: String,
    groupName: String,
    value: Object,
  },
  computed: {
    model: {
      get() {
        return this.value?.[this.tableName]?.[this.groupName]?.[this.item.key];
      },
      set(val) {
        if (!this.value[this.tableName]) this.$set(this.value, this.tableName, {});
        if (!this.value[this.tableName][this.groupName]) this.$set(this.value[this.tableName], this.groupName, {});
        this.$set(this.value[this.tableName][this.groupName], this.item.key, val);
      },
    },
    getMaxLength() {
      return getMaxLength(this.item.validationId);
    },
    },
});
</script>
